export default __webpack_public_path__ + "static/course2-522a27939603504acac21f2451f4c370.jpg";